// [sc-49297] Click su un documento (PDF di preventivo, ordine o DDT) → apertura
// con la sessione, al posto del link diretto all'API. Condiviso da Preventivi,
// Ordini, creazione e modifica del preventivo.

import { nomeDaUrl, openDocument } from "@/utilities/openDocument";

export default {
  methods: {
    // objectName c'è per i DDT (ricavato da documentUrl), per i preventivi è il name
    async openDoc(doc) {
      try {
        await openDocument(doc.objectName ?? doc.name);
      } catch (err) {
        console.error("Errore nell'apertura del documento:", err);
        this.$toast.error("Impossibile aprire il documento");
      }
    },
    // DDT dell'ordine: il nome del file è l'ultima parte di documentUrl
    openDdtDoc(ddt) {
      return this.openDoc({ objectName: nomeDaUrl(ddt.documentUrl) });
    },
  },
};
